import { Switch } from "@mui/material";

const ToggleSwitch = ({ ...prop }) => {
  return <Switch {...prop} />;
};

export default ToggleSwitch;
